<template>
  <div class="avatar" :style="`--avatar-size: ${sizes[size]}`">
    <template v-for="(item, index) in filteredItems">
      <img
        v-if="item.src"
        class="avatar__image"
        :src="item.src"
        :alt="item.name"
        :key="index"
        v-tooltip.bottom="item.name"
        @click="() => $emit('click', item)"
      />
      <div
        v-else
        class="avatar__image avatar__fallback"
        :key="index"
        v-tooltip.bottom="item.name"
        @click="() => $emit('click', item)"
      >
        <FontAwesomeIcon :icon="['fas', 'user']" />
      </div>
    </template>
    <div
      v-if="items.length > max"
      class="avatar__image-more avatar__image"
      v-tooltip.right="{
        content: items
          .slice(max)
          .map(i => i.name)
          .filter(Boolean)
          .join('\n'),
        classes: 'avatar__tooltip',
      }"
    >
      +{{ items.length - max }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String, Object],
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
      validator(val) {
        return ['nano', 'small', 'medium', 'large'].includes(val)
      },
    },
    max: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    items() {
      return (this.value instanceof Array ? this.value : [this.value]).map(e =>
        typeof e === 'string' ? { src: e } : e,
      )
    },
    filteredItems() {
      if (this.items.length <= this.max) return this.items
      return this.items.slice(0, this.max - 1)
    },
    sizes() {
      return {
        nano: '20px',
        small: '30px',
        medium: '40px',
        large: '130px',
      }
    },
  },
}
</script>

<style lang="scss">
.avatar {
  display: flex;
  align-items: center;

  &__fallback {
    display: grid;
    place-items: center;

    svg {
      opacity: 0.3;
    }
  }

  &__tooltip {
    .tooltip-inner {
      display: -webkit-box;
      white-space: pre-wrap;
      overflow: hidden;
      -webkit-line-clamp: 20;
      -webkit-box-orient: vertical;
    }
  }

  &__image {
    border-radius: 20rem;
    background-color: #eaeaea;
    border: 1px solid #d0d0d0;
    aspect-ratio: 1;
    object-fit: cover;
    width: var(--avatar-size);

    &:not(:first-child) {
      margin-left: calc(var(--avatar-size) * -0.4);
    }

    &-more {
      display: grid;
      place-items: center;
      color: css-lighten('dark', 30%);
    }
  }
}
</style>
